import React, { useState, useEffect } from 'react';
import SearchBar from '../SeachBar';

const Billing = () => {

  return (
    <div className="pool-list">
      <h1 className="title">Billing</h1>
    </div>
  );
};

export default Billing;
